/*
==========================================================================================
Не трогать — по этому роуту должны быть эти ссылки, это нужно для аккредитации в минцифры
==========================================================================================
*/

import Header from 'components/landing/Header'
import PageMeta from 'components/base/PageMeta'
import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { withUserProps } from 'lib/contextCreation'
import { getCanonicalHref } from 'lib/canonical'
import { GetServerSideProps } from 'next'

export const getServerSideProps: GetServerSideProps = withUserProps(
  async (context) => {
    if (context.userContext.theme.hostType !== 'sellmonitor') {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        isResponsive: true,
      },
    }
  },
  { forceUnauthorizedMode: true }
)

const Documentation: FC = () => {
  const ctx = useUserContext()
  const canonicalHref = getCanonicalHref(ctx.theme.canonicalURL, '/documentation/')

  return (
    <div>
      <PageMeta
        title={`Документация | ${ctx.theme.title}`}
        description="Документация сервиса Sellmonitor"
        canonical={canonicalHref}
      />
      <Header />
      <div className="px-4 pt-8 pb-32 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <h1 className="text-4xl font-medium">Документация {ctx.theme.title}</h1>
        <div className="mt-8 space-y-6">
          <div>
            <h2 className="text-xl font-medium">Стоимость ПО</h2>
            <p className="mt-2 text-base max-w-prose">
              Sellmonitor не предоставляет экземпляры ПО для самостоятельной установки. Доступ к
              веб-интерфейсу ПО можно получить, оплатив подписку на сайте. Информация о стоимости
              подписки доступна{' '}
              <a href="/#pricing" className="text-primary-600">
                на главной странице
              </a>
              .
            </p>
          </div>
          <div>
            <h2 className="text-xl font-medium">Функциональные характеристики</h2>
            <p className="mt-2 text-base max-w-prose">
              <a
                href="/doc/sellmonitor/ru/functional_characteristics.pdf"
                className="text-primary-600"
              >
                Читать PDF
              </a>
            </p>
          </div>
          <div>
            <h2 className="text-xl font-medium">Инструкция по установке</h2>
            <p className="mt-2 text-base max-w-prose">
              <a href="/doc/sellmonitor/ru/install_instruction.pdf" className="text-primary-600">
                Читать PDF
              </a>
            </p>
          </div>
          <div>
            <h2 className="text-xl font-medium">Процессы поддержания жизненного цикла</h2>
            <p className="mt-2 text-base max-w-prose">
              <a href="/doc/sellmonitor/ru/support_processes.pdf" className="text-primary-600">
                Читать PDF
              </a>
            </p>
          </div>
          <div>
            <h2 className="text-xl font-medium">Руководство пользователя</h2>
            <p className="mt-2 text-base max-w-prose">
              <a href="/doc/sellmonitor/ru/user_manual.pdf" className="text-primary-600">
                Читать PDF
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Documentation
